import { ApplicationError } from '@office-start/application-error';
import { DataSecurityLevel, EVENT_CATEGORY, } from '@office-start/telemetry-types';
import { EventQueue } from '@office-start/telemetry-utility';
import { createEventName, getPageName, isPageViewEvent, setPageDetails, } from './wrappers/logPageView';
var registeredEventSinks = [];
var eventQueue = new EventQueue();
var routeInitialized = false;
var getCurrentRoute;
var eventCategoryConfig;
var appSecurityLevel = DataSecurityLevel.Full;
var telemetryServiceInitialized = false;
/**
 * Function used by other publicly exposed wrapper function to either send
 * the event immediately when all EventSink are registered or buffer it
 * TODO: ADD more unit tests
 *
 * @param eventName Event name
 * @param params Additional data properties for event
 *
 */
export function logEvent(eventName, params, securityThreshold) {
    if (params === void 0) { params = {}; }
    if (appSecurityLevel < securityThreshold) {
        return;
    }
    if (registeredEventSinks.length > 0) {
        registeredEventSinks.forEach(function (sink) {
            if (eventName && isEligible(params)) {
                sink.logEvent(eventName, params);
            }
        });
    }
    else {
        // PageView event name will be set later in drainQueuedEvents after getCurrentRoute is initialized
        if (eventName || (eventName === undefined && isPageViewEvent(params))) {
            var queuedEvent = {
                eventName: eventName,
                params: params,
                securityThreshold: securityThreshold,
            };
            eventQueue.queueEvent(queuedEvent);
        }
    }
}
function drainQueuedEvents() {
    var queuedEvents = eventQueue.drainQueue();
    queuedEvents.forEach(function (event) {
        if (isPageViewEvent(event.params)) {
            event.params = setPageDetails(event.params);
            event.eventName = createEventName(getPageName(event.params));
        }
        logEvent(event.eventName, event.params, event.securityThreshold);
    });
}
export function initializeTelemetryService(sinks, getCurrentRouteFunc, eventTypeConfiguration, initialAppSecurityLevel) {
    if (registeredEventSinks.length > 0) {
        throw new ApplicationError('initializeInstrumentationService is not allowed to be called more than once');
    }
    if (!sinks || sinks.length === 0) {
        throw new ApplicationError('Must specify at least one event factory when calling initializeInstrumentation');
    }
    getCurrentRoute = getCurrentRouteFunc;
    routeInitialized = true;
    eventCategoryConfig = eventTypeConfiguration;
    // Make a copy of the passed array
    registeredEventSinks = sinks.slice();
    if (typeof initialAppSecurityLevel === 'number') {
        appSecurityLevel = initialAppSecurityLevel;
    }
    // Drain queued events for all apps
    drainQueuedEvents();
    telemetryServiceInitialized = true;
}
export function flush() {
    drainQueuedEvents();
    registeredEventSinks.forEach(function (sink) {
        sink.flush();
    });
}
// This function is used by unit test to unregister event sinks
export function shutdown() {
    registeredEventSinks.slice(0, registeredEventSinks.length);
}
export function isRouteInitialized() {
    return routeInitialized;
}
export function getCurrentRouteItem() {
    return getCurrentRoute();
}
export function isEligible(params) {
    switch (params[EVENT_CATEGORY]) {
        case "Action" /* Action */:
            return eventCategoryConfig.actionEnabled;
        case "Diagnostic" /* Diagnostic */:
            return eventCategoryConfig.diagnosticEnabled;
        case "Diagnostic" /* Diagnostic */:
            return eventCategoryConfig.errorEnabled;
        case "Impression" /* Impression */:
            return eventCategoryConfig.impressionEnabled;
        case "PageView" /* PageView */:
            return eventCategoryConfig.pageViewEnabled;
        case "Performance" /* Performance */:
            return eventCategoryConfig.perfEnabled;
        case "Request" /* Request */:
            return eventCategoryConfig.requestEnabled;
        default:
            return false;
    }
}
export function updateAppSecurityLevel(level) {
    appSecurityLevel = level;
}
export function isTelemetryServiceInitialized() {
    return telemetryServiceInitialized;
}
//# sourceMappingURL=TelemetryService.js.map